/* eslint-disable no-dupe-keys */
import React, { useState, useEffect } from "react";
/*import { Upload } from "../../EntryFile/imagePath";*/

import AuthUser from "../../components/AuthUser";

import { toast, ToastContainer } from 'react-toastify';

import Spinner from "../../components/Spinner";

import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';

import Swal from "sweetalert2";

const Novaarea = ({ permissaoAdicionar }) => {

  const history = useHistory();

  // eslint-disable-next-line no-unused-vars
  const { http, url_root, empresa_selecionada } = AuthUser();
  const [nome, setNome] = useState('');
  const [unidade, setUnidade] = useState('');
  const [tamanho, setTamanho] = useState(0);
  const [localizacaoSelecionada, setLocalizacaoSelecionada] = useState(null);
  const [areaSelecionada, setAreaSelecionada] = useState(null);
  const [categoriaSelecionada, setCategoriaSelecionada] = useState(null);
  const [areasmaiores, setAreasmaiores] = useState([]);
  const [localizacoes, setLocalizacoes] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [imagem, setSelectedFile] = useState(null);

  const [permanecerNaPagina, setPermanecerNaPagina] = useState(true);

  const handlePermanecerNaPagina = () => {
    setPermanecerNaPagina(!permanecerNaPagina);
  };

  const navegarParaLista = () => {
    history.push('/dream-pos/area/arealista');
  };

  const navegarParaEdicao = (id) => {
    history.push('/dream-pos/area/areaedit/' + id);
  };

  useEffect(() => {
    getAreasmaiores();
  }, []);

  const getAreasmaiores = async () => {
    try {

      /* Outras areas */

      setLoading(true); // Set loading to true when the request starts

      const resultado = await http.get('/areas');

      setAreasmaiores(resultado.data.areas);

      setCategoriaSelecionada('Argiloso');

      setLoading(false);

      /* Outras areas */

      /* Outras areas */

      setLoading(true); // Set loading to true when the request starts

      const res = await http.get('/regioes');

      setLocalizacoes(res.data.regioes);

      setLoading(false);

      /* Outras areas */


    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.log('Utilizador não autenticado.');
      } else {
        console.log('Ocorreu um erro inesperado. Por favor, tente mais tarde.');
      }
    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  };



  const handleFileChange = (e) => {
    // Lógica para processar a imagem, se necessário
    setSelectedFile(e.target.files[0]);

    // Restante do código
  };

  const toggleLoading = (value) => {
    setLoading(value);
  };

  const submitForm = async () => {

    if (permissaoAdicionar) {
      try {
        toggleLoading(true);

        // Basic form validation
        if (nome.length < 2) {
          setError('O nome deve ter pelo menos dois caracteres.');
          setLoading(false);

          // Show a error toast
          toast.error('O nome deve ter pelo menos dois caracteres.', {
            position: 'top-right',
            autoClose: 3000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });

          return;
        }

        await uploadarea();


      } catch (error) {
        if (error.response && error.response.status === 401) {
          setError('Utilizador não autenticado.');

          // Show a error toast
          toast.error('Utilizador não autenticado.', {
            position: 'top-right',
            autoClose: 3000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });

        } else {
          setError('Ocorreu um erro inesperado. Por favor, tente novamente mais tarde. Verifique tambem se o e-mail ja esta registado');

          // Show a error toast
          toast.error('Ocorreu um erro inesperado. Por favor, tente novamente mais tarde. Verifique tambem se o e-mail ja esta registado', {
            position: 'top-right',
            autoClose: 3000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });

        }
      } finally {
        toggleLoading(false);
      }

    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };


  const uploadarea = async () => {
    try {
      const formData = new FormData();
      formData.append('nome', nome);
      formData.append('tamanho', tamanho);
      formData.append('unidade', unidade);
      formData.append('categoria', categoriaSelecionada);

      formData.append('empresa_id', empresa_selecionada.id);

      if (areaSelecionada != null && areaSelecionada != '')
        formData.append('parent_id', areaSelecionada);

      formData.append('regiao_id', localizacaoSelecionada);
      formData.append('imagem', imagem);
      formData.append('estado', 0);

      const response = await http.post('/area/register', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      // Show a success toast
      toast.success(response.data.message, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        onClose: () => {
          // Redirecionar para a lista de areas após o cadastro bem-sucedido

          setNome('');
          setSelectedFile(null);

          if (!permanecerNaPagina) {
            navegarParaLista();
          } else {
            navegarParaEdicao(response.data.data.id);
          }
        },
      });

    } catch (error) {
      console.error(error);

      toast.error('Ocorreu um erro ao carregar o area. Por favor, tente novamente mais tarde.', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const handleSelectLocalizacaoChange = (id) => {

    setLocalizacaoSelecionada(id);

  };

  const handleSelectCategoriaChange = (id) => {

    if (id == null || id == 'escolha')
      setCategoriaSelecionada('');
    else
      setCategoriaSelecionada(id);

  };

  const handleSelectAreaChange = (id) => {

    if (id == null || id == 'Nenhuma' || id == '')
      setAreaSelecionada(null);
    else
      setAreaSelecionada(id);

  };

  const renderOptions = (areas) => {
    return areas.map((area) => (
      <React.Fragment key={area.id}>
        <option value={area.id}>{area.nome}</option>
        {area.children && area.children.length > 0 && renderOptions(area.children)}
      </React.Fragment>
    ));
  };

  const renderOptionsLocalizacoes = (regions) => {
    return regions.map((region) => (
      <React.Fragment key={region.id}>
        <option value={region.id}>{region.nome}</option>
        {region.children && region.children.length > 0 && renderOptions(region.children)}
      </React.Fragment>
    ));
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="titles">
            <i alt="Image" className="header-image fa fa-braille border p-3 rounded-3"></i>
            <div>
              <h4>Gestão de áreas de plantio</h4>
              <h6>Adicionar área de plantio</h6>
            </div>
          </div>
        </div>
        {/* /add */}
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-3 col-sm-6 col-12">
                <div className="form-group">
                  <label>Nome de área</label>
                  <input type="text" value={nome} onChange={e => setNome(e.target.value)} />
                </div>

                <div className="form-group">
                  <label>Área dentro de :</label>

                  <select
                    name="parent_id"
                    onChange={(e) => handleSelectAreaChange(e.target.value)}
                    value={areaSelecionada == null ? '' : areaSelecionada}
                    className="form-control select"

                  ><option key={0} value={null}>Nenhuma</option>
                    {renderOptions(areasmaiores)}
                  </select>

                </div>

                <div className="form-group">
                  <label>Tamanho</label>
                  <input type="number" className="form-control" value={tamanho} onChange={e => setTamanho(e.target.value)} />
                </div>

              </div>
              <div className="col-lg-3 col-sm-6 col-12">

                <div className="form-group">
                  <label>Tipo de solo</label>

                  <select
                    className="form-control select"
                    onChange={(e) => handleSelectCategoriaChange(e.target.value)}
                    value={categoriaSelecionada == null ? '' : categoriaSelecionada}
                  >
                    <option key={0} value={null}>
                      escolha
                    </option>
                    <option value="Argiloso">Argiloso</option>
                    <option value="Arenoso">Arenoso</option>
                    <option value="Arenoso Argiloso">Arenoso Argiloso</option>
                    <option value="Orgânico">Orgânico</option>
                  </select>


                </div>


                <div className="form-group">
                  <label>Localização</label>

                  <select
                    name="parent_id"
                    onChange={(e) => handleSelectLocalizacaoChange(e.target.value)}
                    value={localizacaoSelecionada}
                    className="form-control select"
                  >
                    <option key={0} value={null}>escolha</option>
                    {renderOptionsLocalizacoes(localizacoes)}
                  </select>

                </div>

                <div className="form-group">
                  <label>Unidade</label>
                  <input type="text" value={unidade} onChange={e => setUnidade(e.target.value)} />
                </div>


                <div className="form-group">
                  {/* Checkbox "Permanecer na Página" */}
                  <label>
                    <input
                      type="checkbox"
                      checked={permanecerNaPagina}
                      onChange={handlePermanecerNaPagina}
                    />
                    &nbsp; Permanecer na Página depois de salvar
                  </label>
                </div>
              </div>
              {/* Restante do código */}
              <div className="col-lg-3 col-sm-6 col-12">
                <div className="form-group">
                  <label>Imagem</label>
                  <div className="image-upload image-upload-new">
                    <input type="file" onChange={handleFileChange} />
                    <div className="image-uploads">
                      {imagem ? (
                        <>
                          <img
                            src={URL.createObjectURL(imagem)}
                            alt="Pré-visualização"
                          />
                          <h4>Carregar imagem</h4>
                        </>
                      ) : (
                        <h4>Carregar imagem</h4>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* Restante do código */}
              <div className="col-lg-12">
                <a onClick={submitForm} className="btn btn-submit me-2">
                  {loading ? <Spinner /> : 'Salvar'}
                </a>
                <a onClick={navegarParaLista} className="btn btn-cancel">
                  Cancelar
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* /add */}
      </div>

      <ToastContainer />

    </div>
  );
};

Novaarea.propTypes = {
  permissaoAdicionar: PropTypes.bool.isRequired
};


export default Novaarea;
